'use client';
import { createElement, ReactNode, ForwardedRef } from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '@/animations';

export interface AnimationProps {
  animate?: boolean;
  animation?: object | ((...args: any[]) => any);
}

export interface IBoxProps extends AnimationProps, React.HTMLAttributes<HTMLElement> {
  tag?: string;
  className?: string;
  children?: ReactNode;
  ref?: ForwardedRef<HTMLElement>;
}

const Box = ({ tag = 'div', animation = fadeInUp, animate = true, children, ...props }: IBoxProps) => {
  const _animate = animate && animation;
  const _motion = _animate ? animation : null;

  return createElement(
    _animate ? getMotionTag(tag) : tag,
    {
      ...props,
      ...(_animate ? _motion : {}),
    },
    children,
  );
};

const getMotionTag = (tag: string) => {
  const tags: { [key: string]: any } = {
    div: motion.div,
    section: motion.section,
    footer: motion.footer,
    header: motion.header,
    picture: motion.picture,
    span: motion.span,
  };

  return tags[tag] || motion.div;
};

Box.displayName = 'Box';

export default Box;
